export const FOLLOW_UP_DROPDOWN = "FOLLOW_UP_DROPDOWN";
export const FOLLOW_UP_FORM = "FOLLOW_UP_FORM";
